import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { RouteConstant } from "../_models/shared/route.constant";
import { AuthService } from "../_services/auth/auth.service";
import { AlertifyService } from "../_services/common/alertify.service";
import { AppSessionState } from "../_services/common/app.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
    private appSessionState: AppSessionState,
    private _alertifyService: AlertifyService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    let url = state.url;
    const menuItem = JSON.parse(localStorage.getItem("MENU") || "[]");
    const allowedRoutes = this.extractRoutesFromMenu(menuItem);

    if (
      this.appSessionState.loggedIn() &&
      (this.isRouteAllowed(url, allowedRoutes) ||
        [
          RouteConstant.USERS_PROFILE,
          RouteConstant.RadiologistProfile,
          RouteConstant.AuthSignupHospital,
          RouteConstant.USERS_2FA_VERIFY,
          RouteConstant.UpdateProfile,
        ].includes(url))
    ) {
      this.authService.setupIdleService();
      return true;
    }

    this._alertifyService.error(
      "You do not have permission to access this menu. Please contact the administrator."
    );
    this.router.navigate(["/login"]);
    return false;
  }

  private isRouteAllowed(url: string, allowedRoutes: string[]): boolean {
    return allowedRoutes.includes(url);
  }

  private extractRoutesFromMenu(menuItems: any[]): string[] {
    let routes: string[] = [];

    menuItems.forEach((item) => {
      if (item.routerLink) {
        routes = routes.concat(item.routerLink);
      }
      if (item.items && item.items.length > 0) {
        routes = routes.concat(this.extractRoutesFromMenu(item.items));
      }
    });

    return routes;
  }
}
